import React from 'react';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

/**
 * Reusable section wrapper that:
 * - Triggers fade+slide animation when scrolled into view
 * - Renders section tag, heading, and gold divider
 */
export function FadeInWhenVisible({ children, delay = 0, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '0px 0px -60px 0px' });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 32 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.65, delay, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeader({ tag, heading, isDark }) {
  return (
    <>
      <FadeInWhenVisible>
        <p className={`font-mono text-xs tracking-[0.18em] mb-3 ${isDark ? 'text-gold/80' : 'text-gold-muted/80'}`}>
          {tag}
        </p>
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.08}>
        <h2
          className={`font-sans font-black leading-tight tracking-tight mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`}
          style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)' }}
          dangerouslySetInnerHTML={{ __html: heading }}
        />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.12}>
        <div className="w-12 h-0.5 bg-gold rounded-full mb-12" />
      </FadeInWhenVisible>
    </>
  );
}
